'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo352x = require('./images/logo35@2x.png');

var _logo352x2 = _interopRequireDefault(_logo352x);

var _h5_windows2x = require('./images/h5_windows@2x.png');

var _h5_windows2x2 = _interopRequireDefault(_h5_windows2x);

var _h5_mac2x = require('./images/h5_mac@2x.png');

var _h5_mac2x2 = _interopRequireDefault(_h5_mac2x);

var _h5_android2x = require('./images/h5_android@2x.png');

var _h5_android2x2 = _interopRequireDefault(_h5_android2x);

var _h5_apple2x = require('./images/h5_apple@2x.png');

var _h5_apple2x2 = _interopRequireDefault(_h5_apple2x);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

require('./H5Index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('url-search-params-polyfill');

var H5Index = function (_React$Component) {
    _inherits(H5Index, _React$Component);

    function H5Index() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, H5Index);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = H5Index.__proto__ || Object.getPrototypeOf(H5Index)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
            beianText: '京ICP备18016017号-8',
            companyEnName: 'Beijing Xiaowei Cloud Service Technology Co., Ltd.',
            helpRecent: [],
            showBeianText: false,
            downloadDisplay: '',
            downloadButton: '',
            downloadLink: '',
            isWindow: true,
            contantUsQQWindows: '',
            contantUsQQMacos: '',
            contantUsEmail: 'service@xiaoweiyunfu.com'
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(H5Index, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var search = new URLSearchParams(location.search);

            var local = _Locale2["default"].GetInstance();
            var lang = local.getLang();
            if (lang === 'chs') {
                this.setState({ showBeianText: true });
            }

            var src = search.get("src");
            if (src == 'macos') {
                this.setState({ isWindow: false });
            }

            document.title = local.getMessagebyId('www_title');

            var downloadHost = 'https://download.dksnote.com';
            var country = 'us';
            if (lang == 'chs') {
                country = 'cn';
                downloadHost = 'https://download.dksnote.com';
            } else if (lang == 'cht') {
                country = 'tw';
            } else if (lang == 'kor') {
                country = 'kr';
            }

            var u = navigator.userAgent;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
                this.setState({ downloadButton: local.getMessagebyId('ios_download') });

                var iOSUrl = 'https://apps.apple.com/' + country + '/app/DkNote/id1570563588';

                this.setState({ downloadLink: iOSUrl });
            } else {
                this.setState({ downloadButton: local.getMessagebyId('android_download') });

                if (lang == 'chs') {
                    this.setState({ downloadLink: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.dksnote.www' });
                    //this.setState( {downloadLink:`${downloadHost}/android/app-dkcweb-universal-release.apk`});
                } else {
                    this.setState({ downloadLink: downloadHost + '/android/app-dkcweb-universal-release.apk' });
                }
            }

            var paramAccess = search.get("access");
            if (null != paramAccess && paramAccess.length > 0) {
                if (paramAccess === 'internal') {
                    this.setState({ downloadDisplay: 'none' });
                }
            }

            if (lang === 'chs') {
                this.GetContantUs();
            }
        }
    }, {
        key: 'GetContantUs',
        value: function GetContantUs() {
            var _this = this;

            fetch('/api/contantus', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {

                _this.setState({ contantUsQQWindows: myJson.vdata.qqwindow });
                _this.setState({ contantUsQQMacos: myJson.vdata.qqmacos });
                _this.setState({ contantUsEmail: myJson.vdata.email });

                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var local = _Locale2["default"].GetInstance();

            var titleText = local.getMessagebyId('www_title');
            var slogan_h5 = local.getMessagebyId('slogan_h5');
            var windows_button = local.getMessagebyId('windows_button');
            var mac_button = local.getMessagebyId('mac_button');
            var iphone_button = local.getMessagebyId('iphone_button');
            var android_button = local.getMessagebyId('android_button');
            var support_system = local.getMessagebyId('support_system');
            var support = local.getMessagebyId('support');
            var content_title1 = local.getMessagebyId('content_title1');
            var content_text1 = local.getMessagebyId('content_text1');
            var content_title2 = local.getMessagebyId('content_title2');
            var content_text2 = local.getMessagebyId('content_text2');
            var content_title3 = local.getMessagebyId('content_title3');
            var content_text3 = local.getMessagebyId('content_text3');
            var content_title4 = local.getMessagebyId('content_title4');
            var content_text4 = local.getMessagebyId('content_text4');
            var content_title5 = local.getMessagebyId('content_title5');
            var content_text5 = local.getMessagebyId('content_text5');
            var content_title6 = local.getMessagebyId('content_title6');
            var content_text6 = local.getMessagebyId('content_text6');

            var support_text1 = local.getMessagebyId('support_text1');
            var support_text2 = local.getMessagebyId('support_text2');
            var support_text3 = local.getMessagebyId('support_text3');

            var image_1;
            var image_2;
            var image_3;
            var image_4;
            var image_5;
            var image_6;

            var lang = local.getLang();

            if (this.state.isWindow) {
                if (lang === 'chs') {
                    image_1 = require('./images/h5_img_chs_win_1.png');
                    image_2 = require('./images/h5_img_chs_win_2.png');
                    image_3 = require('./images/h5_img_chs_win_3.png');
                    image_4 = require('./images/h5_img_chs_win_4.png');
                    image_5 = require('./images/h5_img_chs_win_5.png');
                    image_6 = require('./images/h5_img_chs_win_6.png');
                } else if (lang === 'cht') {
                    image_1 = require('./images/h5_img_cht_win_1.png');
                    image_2 = require('./images/h5_img_cht_win_2.png');
                    image_3 = require('./images/h5_img_cht_win_3.png');
                    image_4 = require('./images/h5_img_cht_win_4.png');
                    image_5 = require('./images/h5_img_cht_win_5.png');
                    image_6 = require('./images/h5_img_cht_win_6.png');
                } else if (lang === 'kor') {
                    image_1 = require('./images/h5_img_kor_win_1.png');
                    image_2 = require('./images/h5_img_kor_win_2.png');
                    image_3 = require('./images/h5_img_kor_win_3.png');
                    image_4 = require('./images/h5_img_kor_win_4.png');
                    image_5 = require('./images/h5_img_kor_win_5.png');
                    image_6 = require('./images/h5_img_kor_win_6.png');
                } else if (lang === 'usa') {
                    image_1 = require('./images/h5_img_usa_win_1.png');
                    image_2 = require('./images/h5_img_usa_win_2.png');
                    image_3 = require('./images/h5_img_usa_win_3.png');
                    image_4 = require('./images/h5_img_usa_win_4.png');
                    image_5 = require('./images/h5_img_usa_win_5.png');
                    image_6 = require('./images/h5_img_usa_win_6.png');
                }
            } else {
                if (lang === 'chs') {
                    image_1 = require('./images/h5_img_chs_1.png');
                    image_2 = require('./images/h5_img_chs_2.png');
                    image_3 = require('./images/h5_img_chs_3.png');
                    image_4 = require('./images/h5_img_chs_4.png');
                    image_5 = require('./images/h5_img_chs_5.png');
                    image_6 = require('./images/h5_img_chs_6.png');
                } else if (lang === 'cht') {
                    image_1 = require('./images/h5_img_cht_1.png');
                    image_2 = require('./images/h5_img_cht_2.png');
                    image_3 = require('./images/h5_img_cht_3.png');
                    image_4 = require('./images/h5_img_cht_4.png');
                    image_5 = require('./images/h5_img_cht_5.png');
                    image_6 = require('./images/h5_img_cht_6.png');
                } else if (lang === 'kor') {
                    image_1 = require('./images/h5_img_kor_1.png');
                    image_2 = require('./images/h5_img_kor_2.png');
                    image_3 = require('./images/h5_img_kor_3.png');
                    image_4 = require('./images/h5_img_kor_4.png');
                    image_5 = require('./images/h5_img_kor_5.png');
                    image_6 = require('./images/h5_img_kor_6.png');
                } else if (lang === 'usa') {
                    image_1 = require('./images/h5_img_usa_1.png');
                    image_2 = require('./images/h5_img_usa_2.png');
                    image_3 = require('./images/h5_img_usa_3.png');
                    image_4 = require('./images/h5_img_usa_4.png');
                    image_5 = require('./images/h5_img_usa_5.png');
                    image_6 = require('./images/h5_img_usa_6.png');
                }
            }

            return _react2["default"].createElement(
                'div',
                { className: 'h5' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo352x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            titleText
                        ),
                        _react2["default"].createElement('div', { className: 'blank' }),
                        _react2["default"].createElement(
                            'a',
                            { style: { display: this.state.downloadDisplay }, className: 'download-btn', href: this.state.downloadLink },
                            this.state.downloadButton
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'banner' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'text' },
                        slogan_h5
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'dividing' },
                        _react2["default"].createElement('span', { className: 'line' }),
                        _react2["default"].createElement(
                            'span',
                            { className: 'text' },
                            support_system
                        ),
                        _react2["default"].createElement('span', { className: 'line' })
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'table' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'row' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'cell' },
                                _react2["default"].createElement('img', { className: 'image', src: _h5_android2x2["default"] }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'text' },
                                    android_button
                                )
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'cell' },
                                _react2["default"].createElement('div', { className: 'dividing' })
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'cell' },
                                _react2["default"].createElement('img', { className: 'image', src: _h5_apple2x2["default"] }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'text' },
                                    iphone_button
                                )
                            )
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'center' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'blockbkgnd1' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'title' },
                            content_title1
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            content_text1
                        ),
                        _react2["default"].createElement('img', { className: 'image', src: image_1 })
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'blockbkgnd2' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'title' },
                            content_title2
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            content_text2
                        ),
                        _react2["default"].createElement('img', { className: 'image', src: image_2 })
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'blockbkgnd1' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'title' },
                            content_title3
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            content_text3
                        ),
                        _react2["default"].createElement('img', { className: 'image', src: image_3 })
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'blockbkgnd2' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'title' },
                            content_title4
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            content_text4
                        ),
                        _react2["default"].createElement('img', { className: 'image', src: image_4 })
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'blockbkgnd1' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'title' },
                            content_title5
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            content_text5
                        ),
                        _react2["default"].createElement('img', { className: 'image', src: image_4 })
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'blockbkgnd2' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'title' },
                            content_title6
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            content_text6
                        ),
                        _react2["default"].createElement('img', { className: 'image', src: image_4 })
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'container' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'title' },
                            support
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'content' },
                            support_text1,
                            this.state.contantUsEmail
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'content' },
                            support_text2,
                            this.state.contantUsQQWindows,
                            support_text3,
                            this.state.contantUsQQMacos
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            'Copyright \xA9 2023 ',
                            this.state.companyEnName
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            '  ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicy' },
                                'Privacy Policy'
                            ),
                            ' / ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'eula' },
                                'EULA'
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'text' },
                            this.state.showBeianText ? _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'http://beian.miit.gov.cn/' },
                                ' ',
                                this.state.beianText
                            ) : null
                        )
                    )
                )
            );
        }
    }]);

    return H5Index;
}(_react2["default"].Component);

exports["default"] = H5Index;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./H5Index.js
// module id = 328
// module chunks = 0